import React from 'react'
import { Box, Button, Flex, Heading, Message, Modal, Text } from '@workwhile/ui'
import { useRestoreQuestionFlowContextValue } from '../context/RestoreQuestionFlowProvider'
import { useRequirementDetailWorkflowsContextValue } from '../../../context/RequirementDetailWorkflowProvider'

export const RestoreQuestionFlowMain = () => {
  const {
    restoreQuestionFlow: { isOpen, close },
  } = useRequirementDetailWorkflowsContextValue()

  const {
    state: { question, isPending, errorMessage },
    actions: { confirm },
  } = useRestoreQuestionFlowContextValue()

  return (
    <Modal
      open={isOpen}
      onClose={close}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={close}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirm}>
            Restore
          </Button>
        </Flex>
      }
    >
      <Heading level={2} m={0}>
        Restore question
      </Heading>
      <Text mt={3} fontSize={3}>
        Are you sure you want to restore this question?
      </Text>

      <Flex mt={3} flexDirection="column" gap={3}>
        <Box>
          <Text fontWeight="bold">Question ({question.id})</Text>
          <Text>"{question.question}"</Text>
        </Box>
      </Flex>

      <Flex mt={3} flexDirection="column" gap={3}>
        <Box color="lightText" fontSize={1}>
          Workers who took assessments without this question will need to answer
          it with Coach before accepting shifts.
        </Box>
      </Flex>

      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
